/* eslint-disable curly */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-cond-assign */
/* eslint-disable one-var */
/* eslint-disable no-var */
/* eslint-disable no-underscore-dangle */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { Injectable } from '@angular/core';
// import 'rxjs/add/operator/map';

declare let window: any;
declare let mixpanel: any;
declare let MIXPANEL_CUSTOM_LIB_URL: any;

@Injectable({ providedIn: 'root' })
export class Mixpanel {
  private codes = {
    playbacpresse: '4e774ffcf4745c7c4c19cb4bb07e8fe2',
    lepq: '237f8625e404447ed580322d93935938',
    mquo: '232b144ae2f5f8ae1ffe45e40c7f95a2',
    actu: 'f893aaccc1b8e79c5fc6d4a03d1e4726',
    aeco: 'edb09259675e8b0bb778da40ac2840dc',
    mlwk: 'c6e62547fc3633032bc535a40d3fe577',
    week: '2ae08f2fce4d1b5d2ea18c6bf6d41e3a',
    woch: '19f646ea42ff376f76bd1d42733e010b',
    sema: 'a7d1ab7c9d05cfff1dc8699a44e3f804',
    mquovideo: '03dcea0c4ca7892c39984bef3daa1568',
    actuvideo: 'e50ba12605e92fbb1a200dd89a49fe65',
  };

  constructor() {}

  runPixelCode(platform) {
    (function(e, a) {
      if (!a.__SV) {
        var b = window;
        try {
          var c,
            l,
            i,
            j = b.location,
            g = j.hash;
          c = function(a, b) {
            return (l = a.match(RegExp(b + '=([^&]*)'))) ? l[1] : null;
          };
          g &&
            c(g, 'state') &&
            ((i = JSON.parse(decodeURIComponent(c(g, 'state')))),
            'mpeditor' === i.action &&
              (b.sessionStorage.setItem('_mpcehash', g),
              history.replaceState(
                i.desiredHash || '',
                e.title,
                j.pathname + j.search
              )));
        } catch (m) {}
        var k, h;
        window.mixpanel = a;
        a._i = [];
        a.init = function(b, c, f) {
          function e(b, a) {
            var c = a.split('.');
            2 === c.length && ((b = b[c[0]]), (a = c[1]));
            b[a] = function() {
              b.push([a].concat(Array.prototype.slice.call(arguments, 0)));
            };
          }
          var d = a;
          'undefined' !== typeof f ? (d = a[f] = []) : (f = 'mixpanel');
          d.people = d.people || [];
          d.toString = function(b) {
            var a = 'mixpanel';
            'mixpanel' !== f && (a += '.' + f);
            b || (a += ' (stub)');
            return a;
          };
          d.people.toString = function() {
            return d.toString(1) + '.people (stub)';
          };
          k =
            'disable time_event track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config reset people.set people.set_once people.increment people.append people.union people.track_charge people.clear_charges people.delete_user'.split(
              ' '
            );
          for (h = 0; h < k.length; h++) e(d, k[h]);
          a._i.push([b, c, f]);
        };
        a.__SV = 1.2;
        b = e.createElement('script');
        b.type = 'text/javascript';
        b.async = !0;
        b.src =
          'undefined' !== typeof MIXPANEL_CUSTOM_LIB_URL
            ? MIXPANEL_CUSTOM_LIB_URL
            : 'file:' === e.location.protocol &&
              '//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js'.match(/^\/\//)
            ? 'https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js'
            : '//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js';
        c = e.getElementsByTagName('script')[0];
        c.parentNode.insertBefore(b, c);
      }
    })(document, window.mixpanel || []);
    mixpanel.init(this.codes[platform]);
  }
}
